import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import { IMPRESION_ETIQUETA } from '../../../common/types/parametroType';

import establecimientoService from '../../../service/administracion/establecimientoService';
import marcaService from '../../../service/administracion/marcaService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import impresionEtiquetaService from '../../../service/administracion/impresionEtiquetaService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            establecimientos: [],
            marcas: [],
            monedas: [],
            listaPrecios: [],
            listaPreciosAll: [],
            filter: {
                nombre: "",
                codigoReferencia: "",
                codigoBarra: "",
                idMarca: 0,
                idEstablecimiento: 0,
                idListaPrecio: 0,
                idMoneda: 1,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: "",
            idEstablecimiento: 0,
            codigotipoEstablecimiento: '',
            establecimientos: [],
            monedas: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombre: "",
            codigoReferencia: "",
            codigoBarra: "",
            idMarca: 0,
            idEstablecimiento: this.state.filter.idEstablecimiento,
            idListaPrecio: this.state.filter.idListaPrecio,
            idMoneda: 1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        var filter = { ...this.state.filter, [property]: value };

        if (property === 'idEstablecimiento') {
            const listaPrecios = this.state.listaPreciosAll.filter(m => [value].includes(m.idEstablecimiento));
            filter.idListaPrecio = listaPrecios.length > 0 ? listaPrecios[0].id : 0;
            this.setState({ listaPrecios });
        }

        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await impresionEtiquetaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await impresionEtiquetaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Almacén.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await impresionEtiquetaService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }


    /******************** FORM MODAL *****************/


    handleEtiqueta = async (values) => {

        var disabledPrint = auth.user().parametros.filter(m => m.abreviatura === IMPRESION_ETIQUETA)[0].valor === "1" ? true : false;
        if (!disabledPrint) {
            message.warning('Opción no disponible en su plan actual, contacte a un asesor comercial.');
            return false;
        }

        if (values.codigoBarra == null || values.codigoBarra == undefined) {
            dialog.error('El producto ' + values.nombre + ' no tiene código de barra');
            return;
        }

        var formValues = new Object();
        formValues.codigoBarra = values.codigoBarra;
        formValues.codigoReferencia = values.codigoReferencia;
        formValues.establecimiento = values.establecimiento;
        formValues.nombre = values.nombre;
        formValues.numeroLote = values.numeroLote;
        formValues.stockDisponible = values.stockDisponible;
        formValues.precioUnitarioDolares = values.precioUnitarioDolares;
        formValues.precioUnitarioSoles = values.precioUnitarioSoles;
        formValues.nombreMarca = values.nombreMarca;

        formValues.monedas = this.state.monedas;
        formValues.idMoneda = 1;

        this.setState({ visible: true, formValues });

    };



    handleSave = async (values, form) => {


        if (values.codigoBarra == null || values.codigoBarra == undefined) {
            dialog.error('El producto ' + values.nombre + ' no tiene código de barra');
            return;
        }
        this.setState({ loadingEdit: true });
        var response = await impresionEtiquetaService.etiqueta(values);
        this.setState({ loadingEdit: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }

    };

    async componentDidMount() {

        const listaPrecios = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();

        var idListaPrecio = listaPrecios.length > 0 ? listaPrecios[0].id : 0;
        var idEstablecimiento = establecimientos.length > 0 ? establecimientos[0].id : 0;

        this.setState({ filter: { ...this.state.filter, idListaPrecio, idEstablecimiento } });
        this._initPagination({ ...this.state.filter, idListaPrecio, idEstablecimiento }, impresionEtiquetaService.paginacion);


        const listaPreciosFilter = listaPrecios.filter(m => [idEstablecimiento].includes(m.idEstablecimiento));


        const marcas = await marcaService.listar();
        const monedas = await monedaService.listar();

        this.setState({
            loadingSource: false,
            establecimientos: establecimientos ? establecimientos : [],
            marcas: marcas ? marcas : [],
            monedas: monedas ? monedas : [],
            listaPrecios: listaPreciosFilter ? listaPreciosFilter : [],
            listaPreciosAll: listaPrecios ? listaPrecios : [],
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Impresión de etiquetas"

                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    marcas={this.state.marcas}
                    monedas={this.state.monedas}
                    listaPrecios={this.state.listaPrecios}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    //onExportExcel={this.handleExportExcel}
                    //onExportPdf={this.handleExportPdf}
                    //onPrint={this.handlePrint}
                    onEdit={this.handleEtiqueta}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}